"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioGroup = exports.RadioLabel = exports.RadioDot = exports.RadioCircle = exports.GroupLabel = exports.Input = exports.InputWrapper = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledComponentsRtl = _interopRequireDefault(require("styled-components-rtl"));
var _polished = require("polished");
var _templateObject;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var InputWrapper = _styledComponents.default.span.withConfig({
  displayName: "style__InputWrapper",
  componentId: "sc-1xm4ann-0"
})(["position:relative;"]);
exports.InputWrapper = InputWrapper;
var Input = _styledComponents.default.input.withConfig({
  displayName: "style__Input",
  componentId: "sc-1xm4ann-1"
})(["", ""], (0, _polished.hideVisually)());
exports.Input = Input;
var GroupLabel = _styledComponents.default.label.withConfig({
  displayName: "style__GroupLabel",
  componentId: "sc-1xm4ann-2"
})(["user-select:none;cursor:pointer;display:inline-block;justify-content:center;align-items:center;", " ", ""], function (_ref) {
  var checked = _ref.checked;
  return checked && (0, _styledComponents.css)(["color:", ";svg{color:", ";}background-color:", ";"], function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.brandPrimaryContrast;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.brandPrimaryContrast;
  }, function (_ref4) {
    var theme = _ref4.theme;
    return theme.colors.brandPrimary;
  });
}, function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled && (0, _styledComponents.css)(["cursor:initial;opacity:0.6;pointer-events:none;"]);
});
exports.GroupLabel = GroupLabel;
var RadioCircle = _styledComponents.default.span.withConfig({
  displayName: "style__RadioCircle",
  componentId: "sc-1xm4ann-3"
})(["border:1px solid ", ";background-color:", ";display:inline-block;border-radius:50%;vertical-align:top;text-align:center;", " padding:", ";", ""], function (_ref6) {
  var theme = _ref6.theme,
    light = _ref6.light;
  return light ? theme.palette.white : theme.palette.gray100;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.ui00;
}, (0, _styledComponentsRtl.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-right: ", ";\n  "])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.md;
}), function (_ref9) {
  var theme = _ref9.theme;
  return theme.space.xxs;
}, function (_ref10) {
  var hasFocus = _ref10.hasFocus;
  return hasFocus && (0, _styledComponents.css)(["outline-color:-webkit-focus-ring-color;outline-style:none;"]);
});
exports.RadioCircle = RadioCircle;
var RadioDot = _styledComponents.default.div.withConfig({
  displayName: "style__RadioDot",
  componentId: "sc-1xm4ann-4"
})(["border:1px solid transparent;background-color:transparent;width:", ";height:", ";border-radius:50%;margin:auto;transition:", ";"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.space.sm;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.space.sm;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.animation.transitionMedium;
});
exports.RadioDot = RadioDot;
var RadioLabel = _styledComponents.default.label.withConfig({
  displayName: "style__RadioLabel",
  componentId: "sc-1xm4ann-5"
})(["display:flex;align-items:center;cursor:pointer;line-height:", ";color:", ";font-size:", ";margin-bottom:", ";", " ", " ", ""], function (_ref14) {
  var theme = _ref14.theme;
  return theme.lineHeight.lg;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.input.textColor;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.input.fontSize;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.space.sm;
}, function (_ref18) {
  var checked = _ref18.checked;
  return checked && (0, _styledComponents.css)(["", "{background-color:", ";}"], RadioDot, function (_ref19) {
    var theme = _ref19.theme,
      light = _ref19.light;
    return light ? theme.palette.white : theme.colors.brandPrimary;
  });
}, function (_ref20) {
  var disabled = _ref20.disabled;
  return disabled && (0, _styledComponents.css)(["cursor:initial;opacity:0.6;pointer-events:none;"]);
}, function (_ref21) {
  var light = _ref21.light;
  return light && (0, _styledComponents.css)(["color:", ";"], function (_ref22) {
    var theme = _ref22.theme;
    return theme.formField.labelColorLight;
  });
});
exports.RadioLabel = RadioLabel;
var FullWidthCss = (0, _styledComponents.css)(["display:flex;width:100%;", "{width:100%;position:relative;text-align:center;}@media (max-width:", "){display:block;}"], GroupLabel, function (_ref23) {
  var theme = _ref23.theme;
  return theme.breakpoints.md;
});
var RadioGroup = _styledComponents.default.div.withConfig({
  displayName: "style__RadioGroup",
  componentId: "sc-1xm4ann-6"
})(["margin-bottom:", ";", ""], function (_ref24) {
  var theme = _ref24.theme;
  return theme.space.lg;
}, function (_ref25) {
  var flow = _ref25.flow;
  return !flow ? (0, _styledComponents.css)(["", ";@media (max-width:", "){", ";}"], function (_ref26) {
    var fullWidth = _ref26.fullWidth;
    return fullWidth && FullWidthCss;
  }, function (_ref27) {
    var theme = _ref27.theme;
    return theme.breakpoints.md;
  }, FullWidthCss) : (0, _styledComponents.css)([""]);
});
exports.RadioGroup = RadioGroup;